// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7806":"fb4215a55016feb2","8922":"3664f52a80db6578"}[chunkId] + ".js";
};